<template>
    <div>
        <b-card class="mt-md-1 mt-2">
            <h4 class="mb-0 text-info font-weight-bolder">اطلاعات انبارگردانی</h4>
            <b-row>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">شماره انبارگردانی</h5>
                            <h4 class="mb-0">{{ stockTakingDetails.number ? stockTakingDetails.number : 'ثبت نشده' }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-info">
                                    <feather-icon size="20" icon="BoxIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">تاریخ ثبت</h5>
                            <h4 class="mb-0">
                                <span>
                                    {{ new Date(stockTakingDetails.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(stockTakingDetails.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-info">
                                    <feather-icon size="20" icon="CalendarIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">نام انبار</h5>
                            <h4 class="mb-0">{{ stockTakingDetails.warehouse.name }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="BoxIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">وضعیت مغایرت</h5>
                            <h4 class="mb-0">
                                {{ stockTakingDetails.hasConflict ? 'مغایرت دارد' : 'مغایرت ندارد' }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="RepeatIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">ثبت یا ویرایش‌ کننده</h5>
                            <h4 class="mb-0">
                                {{ stockTakingDetails.lastModifiedByUser.firstName + " " +
                                    stockTakingDetails.lastModifiedByUser.lastName }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="UserIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">وضعیت انبارگردانی</h5>
                            <h4 class="mb-0" :class="stockTakingDetails.isFinalized ? 'text-success' : 'text-warning'">
                                {{ stockTakingDetails.isFinalized ? 'تایید شده' : 'در انتظار تایید' }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="RepeatIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">تاریخ تایید</h5>
                            <h4 v-if="stockTakingDetails.finalizedAt" class="mb-0">
                                <span>
                                    {{ new Date(stockTakingDetails.finalizedAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(stockTakingDetails.finalizedAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </h4>
                            <h4 v-else class="mb-0">
                                ثبت نشده
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="CalendarIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">تایید کننده</h5>
                            <h4 v-if="stockTakingDetails.finalizedByUser" class="mb-0">
                                {{ stockTakingDetails.finalizedByUser.firstName + " " +
                                    stockTakingDetails.finalizedByUser.lastName }}
                            </h4>
                            <h4 v-else class="mb-0">
                                ثبت نشده
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="UserIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col v-if="stockTakingDetails.description" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">توضیحات</h5>
                            <h5 class="mb-0">{{ stockTakingDetails.description }}
                            </h5>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="FileTextIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <b-card v-if="stockTakingDetails" no-body class="mb-2">
            <b-table responsive :items="stockTakingDetails.items" :fields="fields" hover bordered class="mb-0">
                <template #cell(previousQuantity)="data">
                    {{
                        [101, 100].includes(data.item.displayUnit) ? data.item.previousQuantity / 1000 :
                            data.item.previousQuantity
                    }}
                </template>
                <template #cell(discrepancyQuantity)="data">
                    {{
                        [101, 100].includes(data.item.displayUnit) ? data.item.discrepancyQuantity / 1000 :
                            data.item.discrepancyQuantity
                    }}
                </template>
                <template #cell(countedQuantity)="data">
                    {{
                        [101, 100].includes(data.item.displayUnit) ? data.item.countedQuantity / 1000 :
                            data.item.countedQuantity
                    }}
                </template>
                <template #cell(displayUnit)="data">
                    {{ displayUnit_management(data.item.displayUnit) }}
                </template>
            </b-table>
        </b-card>

    </div>
</template>

<script>
import { BCard, BRow, BCol, BAvatar, BMediaAside, BMedia, BButton, BTable, VBPopover } from 'bootstrap-vue';

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BAvatar,
        BMediaAside,
        BMedia,
        BButton,
        BTable
    },
    directives: {
        'b-popover': VBPopover,
    },
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: 'نام ماده (کالا)',
                },
                {
                    key: 'displayUnit',
                    label: 'واحد اندازه گیری',
                },
                {
                    key: 'previousQuantity',
                    label: 'موجودی',
                },
                {
                    key: 'countedQuantity',
                    label: 'مقدار شمارش شده',
                },
                {
                    key: 'discrepancyQuantity',
                    label: 'مغایرت',
                },
            ],
        }
    },
    props: {
        stockTakingDetails: {
            type: Object,
            default: () => { },
        },
    },
    computed: {
        displayUnit_management() {
            return (status) => {
                if (status == 1) {
                    return 'گرم'
                }
                if (status == 100) {
                    return 'کیلوگرم'
                }
                if (status == 2) {
                    return 'میلی‌لیتر'
                }
                if (status == 101) {
                    return 'لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
    },
};
</script>